import BroadcasterProfile from "../container/user/broadcaster/profile";
import ViewerProfile from "../container/user/profile";

export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export const API_ENDPOINT_V2 =process.env.REACT_APP_API_ENDPOINTV2
export const X_AUTHORIZATION = process.env.REACT_APP_X_AUTHORIZATION;
export const AUTH_HEADERS = { 'X-Authorization': X_AUTHORIZATION, 'Content-Type': 'application/json', };
export const X_AUTH_HEADERS = { 'X-Authorization': X_AUTHORIZATION};
export const APP_VERSION = process.env.REACT_APP_VERSION;
export const BUILD_VERSION = process.env.REACT_APP_BUILD_VERSION;
export const FREEGEOIP = process.env.REACT_APP_FREEGEOIP;
export const TOKBOX_APIKEY = process.env.REACT_APP_TOKBOX_APIKEY;

export const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_apiKey;
export const FIREBASE_AUTH_DOMAIN = process.env.REACT_APP_FIREBASE_authDomain;
export const FIREBASE_DATABASE_URL = process.env.REACT_APP_FIREBASE_databaseURL;
export const FIREBASE_PROJECTID = process.env.REACT_APP_FIREBASE_projectId;
export const FIREBASE_STORAGE_BUCKET = process.env.REACT_APP_FIREBASE_storageBucket;
export const FIREBASE_MESSAGING_SENDERID = process.env.REACT_APP_FIREBASE_messagingSenderId;
export const FIREBASE_MESSAGING_APPID = process.env.REACT_APP_FIREBASE_appId;
export const FIREBASE_MESSAGING_PUBLIC_KEY = process.env.REACT_APP_FIREBASE_PUBLIC_KEY;

export default {
    HOME: "HOME",
    BROADCASTER_PROFILE:"BROADCASTER_PROFILE",
    VIEWER_PROFILE:"VIEWER_PROFILE"
}